import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_SECTIONS: (state, sections) => {
        state.sections = sections;
    },
    SET_SECTIONS_FOR_CURRENT_USER:(state, sections)=>{
      state.sectionsForCurrentUser = sections;
    },
    SET_SECTION: (state, section) => {
        state.section = section;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_SECTION_TO_EDIT: (state, sectionToEdit) => {
        state.sectionToEdit = sectionToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}